import { request } from './http';
import type { CardBin, CardLifecycleStatus, CardSecret, VccCard } from '@/types/card';
import type { PaginatedResult } from '@/types/api';

export interface CardListQuery {
  status?: CardLifecycleStatus;
  bin?: string;
  keyword?: string;
  page?: number;
  pageSize?: number;
}

export interface CardCreateRequest {
  bin: string;
  alias: string;
  billingProfileId: string;
  /** 初始限额（整数美分） */
  totalLimitCents: number;
  /** 是否常驻可充值 */
  reloadable: boolean;
}

export interface CardFundsRequest {
  /** 调拨金额（整数美分，正数） */
  amountCents: number;
  /** 业务备注 */
  remark?: string;
}

export const cardsApi = {
  /** 获取所有可用卡段 */
  listBins() {
    return request<CardBin[]>({ url: '/cards/bins', method: 'GET' });
  },
  /** 卡列表（分页） */
  list(query: CardListQuery = {}) {
    return request<PaginatedResult<VccCard>>({ url: '/cards', method: 'GET', params: query });
  },
  /** 单张卡详情 */
  detail(cardId: string) {
    return request<VccCard>({ url: `/cards/${cardId}`, method: 'GET' });
  },
  /** 申请开卡 */
  create(payload: CardCreateRequest) {
    return request<VccCard>({ url: '/cards', method: 'POST', data: payload });
  },
  /** 充值（母账户 → 卡余额） */
  refill(cardId: string, payload: CardFundsRequest) {
    return request<{ orderNo: string }>({
      url: `/cards/${cardId}/refill`,
      method: 'POST',
      data: payload,
    });
  },
  /** 提现（卡余额 → 母账户） */
  withdraw(cardId: string, payload: CardFundsRequest) {
    return request<{ orderNo: string }>({
      url: `/cards/${cardId}/withdraw`,
      method: 'POST',
      data: payload,
    });
  },
  /** 销卡 */
  close(cardId: string) {
    return request<{ orderNo: string }>({
      url: `/cards/${cardId}/close`,
      method: 'POST',
    });
  },
  /** 二次验证后获取明文卡号 / CVV */
  revealSecret(cardId: string, payload: { stepUpToken: string }) {
    return request<CardSecret>({
      url: `/cards/${cardId}/secret`,
      method: 'POST',
      data: payload,
    });
  },
};
